import { z } from 'zod';
import { passwordPolicySchema } from './password';
export const recoveryCsrfResponseSchema = z.object({
    csrfToken: z.string(),
    resetTtlMinutes: z.number().int().positive(),
});
export const recoveryStartRequestSchema = z.object({
    email: z.email().max(254),
    locale: z.enum(['en', 'de']).optional(),
});
export const recoveryCompleteRequestSchema = z.object({
    token: z.string().max(512),
    newPassword: passwordPolicySchema,
});
export const recoveryOkResponseSchema = z.object({
    status: z.literal('ok'),
});
export const recoveryCompleteResponseSchema = z.object({
    status: z.enum(['ok', 'invalid_token']),
});
//# sourceMappingURL=recovery.js.map